export const getDraftMessage = (phoneNumber: string): string => {
    let drafts = JSON.parse(sessionStorage.getItem("_drafts_") || "{}");
    return drafts ? drafts[phoneNumber] || "" : "";
}

export const deleteDraftMessage = (phoneNumber: string) => {
    let drafts: any = sessionStorage.getItem("_drafts_");
    drafts = JSON.parse(drafts);
    if (drafts) {
        delete drafts[phoneNumber];
    }
    sessionStorage.setItem("_drafts_", JSON.stringify(drafts));
}

export const setDraftMessage = (phoneNumber: string, draft: string) => {
    let drafts: any = sessionStorage.getItem("_drafts_");
    if (drafts) {
        drafts = JSON.parse(drafts) || {};
        drafts[phoneNumber] = draft;
    }
    else {
        drafts = { [phoneNumber]: draft };
    }
    sessionStorage.setItem("_drafts_", JSON.stringify(drafts));
}